// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__gb0Eq","blog":"styles_blog__2HZ9V","title":"styles_title__1xdT2","description":"styles_description__vfY-F","button":"styles_button__2lTDx"};